import api from 'src/shared/api/axios';

export type OrgMember = {
    id: string;
    projectId: string;
    orgId: string;
    userId: string;
    canEvEntry: boolean;
    user: {
        id: string;
        email?: string | null;
        name?: string | null;
    };
};

type ListRes = { ok: boolean; result: OrgMember[] };
type OneRes = { ok: boolean; result: OrgMember };

export async function listOrgMembers(projectId: string, orgId: string): Promise<OrgMember[]> {
    const { data } = await api.get<ListRes>(`/projects/${projectId}/orgs/${orgId}/members`);
    return Array.isArray(data?.result) ? data.result : [];
}

export async function addOrgMember(
    projectId: string,
    orgId: string,
    userId: string,
    canEvEntry = false,
): Promise<OrgMember> {
    const { data } = await api.post<OneRes>(`/projects/${projectId}/orgs/${orgId}/members`, { userId, canEvEntry });
    return data.result;
}

export async function updateOrgMember(
    projectId: string,
    orgId: string,
    memberId: string,
    canEvEntry: boolean,
): Promise<OrgMember> {
    const { data } = await api.patch<OneRes>(`/projects/${projectId}/orgs/${orgId}/members/${memberId}`, {
        canEvEntry,
    });
    return data.result;
}

export async function removeOrgMember(projectId: string, orgId: string, memberId: string) {
    const { data } = await api.delete(`/projects/${projectId}/orgs/${orgId}/members/${memberId}`);
    return data;
}
